var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// ==========================================================
// 愿望清单相关的全局函数
// 这些函数被提取出来，以便在任何地方都能调用
// ==========================================================

const updateWishlistCountBubble = () => {
    const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
    const count = wishlistData.length;
    const countElements = document.querySelectorAll('#bottom-toolbar-wishlist-count');
    countElements.forEach((element) => {
        element.textContent = count;
        element.dataset.wishlistCount = count;
    });
};

const handleWishedButtonStatus = () => {
    // 获取所有愿望清单按钮
    let allWishlistButtons = document.querySelectorAll('.sm-quick-wish__submit');
    
    // 先移除所有按钮上的 active 类，以确保状态同步
    allWishlistButtons.forEach(btn => {
        btn.classList.remove("active");
    });
    
    // 获取当前的愿望清单数据
    const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
    
    // 遍历愿望清单中的每个商品，给对应的按钮添加 active 类
    for (let item of wishlistData) {
        const handle = item.split(";")[0];
        let wishedButtons = document.querySelectorAll(`.sm-quick-wish__submit[data-product-handle="${handle}"]`);
        wishedButtons.forEach((element) => {
            element.classList.add("active");
        });
    }
};

const showWishlistToast = (text) => {
    if (!text)
        return;
    const oldToast = document.querySelector(".sm-wishlist-toast");
    if (oldToast) {
        oldToast.remove();
    }
    const toast = document.createElement("div");
    toast.className = "sm-wishlist-toast";
    toast.textContent = text;
    document.body.appendChild(toast);
    window.setTimeout(() => {
        toast.classList.add("is-hiding");
    }, 2800);
    window.setTimeout(() => {
        toast.remove();
    }, 3000);
};

// ==========================================================
// QuickWishModal 类（用于弹窗功能）
// ==========================================================
if (!customElements.get("quick-wish-modal")) {
  class QuickWishModal extends ModalDialog {
    constructor() {
      super();
      // 在这里不再定义这两个方法，因为它们现在是全局函数了
      const { productHandle, pixelListId, pixelListName, pixelIndex } = this.dataset;
      this.productHandle = productHandle;
      this.modalContent = this.querySelector('[id^="quick-wish-info-"]');
      this.pixel = {
        index: pixelIndex,
        id: pixelListId,
        name: pixelListName
      };
      this.addEventListener("variant-change", this.onVariantChange);
      // 在实例初始化时调用，确保页面加载时数量正确
      updateWishlistCountBubble();
    }
    getElements() {
      this.elements = {
        form: this.querySelector(".sm-quick-wish__form"),
        input: this.querySelector('input[name="id"]'),
        createListButton: this.querySelector('.sm-quick-wish__block[data-type="button"] button[type="button"]'),
        addToListButton: this.querySelector('.sm-quick-wish__block[data-type="button"] button[type="submit"]')
      };
    }
    setupEventListeners() {
      var _a;
      this.elements.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      (_a = this.elements.createListButton) == null ? void 0 : _a.addEventListener("click", this.handleCreateListButtonClick.bind(this));
    }
    onVariantChange({ detail }) {
      const { currentVariant } = detail;
      this.elements.input.value = currentVariant.id;
      const images = this.querySelectorAll(".sm-quick-wish__media img");
      images.forEach((img) => {
        if (img.dataset.mediaId === String(currentVariant.featured_media.id)) {
          img.removeAttribute("hidden");
        } else {
          img.setAttribute("hidden", "");
        }
      });
      currentVariant.options.forEach((option, index) => {
        const optionElement = this.querySelector(`.sm-quick-wish__info-options [data-position="${index + 1}"]`);
        optionElement.innerHTML = option;
        optionElement.setAttribute("data-checked", option);
      });
    }
    dispatchOpenedEvent() {
      document.body.dispatchEvent(
        new CustomEvent("productCardModalOpened", {
          detail: {
            product: this.product,
            pixel: this.pixel
          }
        })
      );
    }
    preventDuplicatedIDs(element) {
      const sectionId = element.dataset.section;
      element.innerHTML = element.innerHTML.replace(
        new RegExp(`\\b${sectionId}\\b`, "g"),
        `${sectionId}_${this.dataset.productId}`
      );
      element.querySelectorAll("variant-selects, product-info").forEach((element2) => {
        element2.dataset.originalSection = sectionId;
      });
    }
    open(opener) {
      if (this.modalContent.innerHTML) {
        super.open(opener);
        setTimeout(() => {
          this.dispatchOpenedEvent();
        }, 300);
        return;
      }
      opener == null ? void 0 : opener.setAttribute("disabled", "disabled");
      opener == null ? void 0 : opener.setAttribute("aria-disabled", true);
      opener.querySelector(".sm-loading").classList.remove("hidden");
      fetch(`${window.Shopify.routes.root}products/${this.productHandle}?section_id=quick-wish`).then((response) => response.text()).then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const replaceElement = responseHTML.querySelector('[id^="quick-wish-"]');
        if (replaceElement) {
          this.preventDuplicatedIDs(replaceElement);
          window.setInnerHTML(this.modalContent, replaceElement.innerHTML);
        }
        this.getElements();
        this.setupEventListeners();
        super.open(opener);
        const jsonScript = responseHTML.querySelector(`[data-name="json-pixel-products"][type="application/json"]`);
        if (jsonScript) {
          const productJson = jsonScript.textContent;
          const product = JSON.parse(productJson) || [];
          product.pixelIndex = this.pixel.index;
          this.product = product;
          this.dispatchOpenedEvent();
        }
      }).finally(() => {
        opener == null ? void 0 : opener.removeAttribute("disabled");
        opener == null ? void 0 : opener.removeAttribute("aria-disabled");
        opener.querySelector(".sm-loading").classList.add("hidden");
      });
    }
    onSubmitHandler(event) {
      var _a, _b;
      event.preventDefault();
      const wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
      const variantId = this.elements.input.value;
      const variant = this.product.variants.find((v) => v.id == variantId);
      wishlistData.unshift(this.product.handle + ";" + variant.id);
      localStorage.setItem(window.WISHLIST_PARAMS.key, JSON.stringify([...new Set(wishlistData)].slice(0, 50)));
      // 调用全局函数来更新 UI
      updateWishlistCountBubble();
      handleWishedButtonStatus();
      window.publish(window.PUB_SUB_EVENTS.wishlistUpdate, { product: this.product, variant, pixel: this.pixel });
      showWishlistToast((_b = (_a = window.quickWishStrings) == null ? void 0 : _a.tips) == null ? void 0 : _b.addedAuccessfully);
    }
  }
  customElements.define("quick-wish-modal", QuickWishModal);
}

// ==========================================================
// 用于直接添加到愿望清单的逻辑（不打开弹窗）
// ==========================================================

const handleDirectAddToWishlist = (event) => {
  event.preventDefault();
  event.stopPropagation();

  const button = event.currentTarget;
  const productHandle = button.dataset.productHandle;
  const variantId = button.dataset.variantId;

  if (!productHandle || !variantId) return;

  let wishlistData = JSON.parse(localStorage.getItem(window.WISHLIST_PARAMS.key)) || [];
  const isProductWished = wishlistData.some((item) => item.split(";")[0] === productHandle);

  if (isProductWished) {
    wishlistData = wishlistData.filter((item) => item.split(";")[0] !== productHandle);
  } else {
    wishlistData.unshift(`${productHandle};${variantId}`);
  }

  localStorage.setItem(
    window.WISHLIST_PARAMS.key,
    JSON.stringify([...new Set(wishlistData)].slice(0, 50))
  );

  updateWishlistCountBubble();
  handleWishedButtonStatus();

  if (window.publish && window.PUB_SUB_EVENTS) {
    window.publish(window.PUB_SUB_EVENTS.wishlistUpdate, {});
  }
};

const setupDirectWishButtons = () => {
  document.querySelectorAll(".sm-quick-wish__submit[data-direct-wish]").forEach((button) => {
    if (button.dataset.directWishBound) return;
    button.dataset.directWishBound = "true";
    button.addEventListener("click", handleDirectAddToWishlist);
  });
};

const initWishlistUI = () => {
  updateWishlistCountBubble();
  handleWishedButtonStatus();
  setupDirectWishButtons();
};

document.addEventListener("DOMContentLoaded", initWishlistUI);
document.addEventListener("shopify:section:load", initWishlistUI);

document.addEventListener("variant-change", (event) => {
  const { currentVariant } = event.detail || {};
  if (!currentVariant) return;
  document.querySelectorAll(".sm-quick-wish__submit[data-direct-wish]").forEach((button) => {
    button.dataset.variantId = currentVariant.id;
  });
});